import { render, staticRenderFns } from "./MenuLeft.vue?vue&type=template&id=25a71f9c&scoped=true"
import script from "./MenuLeft.vue?vue&type=script&lang=js"
export * from "./MenuLeft.vue?vue&type=script&lang=js"
import style0 from "./MenuLeft.vue?vue&type=style&index=0&id=25a71f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a71f9c",
  null
  
)

export default component.exports